<template>
  <div class="animated fadeIn">
    <template v-if="permissions.length">
      <b-table
        :items="permissions"
        :fields="table.fields"
        :per-page="table.per_page"
        v-sortable="table.sorts"
        :current-page="table.current_page"
        id="permission-table"
        bordered
        striped
        hover
        responsive
      >
        <template #cell(permission_name)="data">
          {{ data.item.name }}
        </template>
      </b-table>
      <custom-table-pagination
        :current_page="table.current_page"
        :per_page="table.per_page"
        :total_rows="table.total_rows"
        table_id="permission-table"
        @update="updatePaginationData"
      />
    </template>
    <b-alert v-else show class="py-1 m-0">
      <i class="fa fa-exclamation-circle" /> No permissions found.
    </b-alert>
  </div>
</template>

<script>
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import sortable from "@/components/shared/directives/Sortable";

export default {
  name: "PermissionTable",
  components: {
    CustomTablePagination,
  },
  directives: { sortable },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      table: {
        fields: [{ key: "permission_name", label: "Permission Name" }],
        current_page: 1,
        per_page: 10,
        total_rows: this.permissions.length,
        sorts: null,
      },
    };
  },
  methods: {
    updatePaginationData({ value }) {
      this.table.current_page = value;
    },
  },
};
</script>
